import React from 'react'
import onlineVisitBannerImage from '../../assets/img/online-visit/online-visit-image-banner.png'
import { connect } from 'react-redux'
import { getOnlineVisitUrl } from '../../store/login/reducers'
import Translation from '../global/Translation'

const OnlineVisitBanner = props => {
    const { onlineVisitUrl } = props

    const backgroundImageStyle = {
        backgroundImage: `url('${onlineVisitBannerImage}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        color: 'white'
    }

    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1
    }

    const contentStyle = {
        zIndex: 2
    }

    return (
        <div className="banner-online-visit-container" style={backgroundImageStyle}>
            <div style={overlayStyle}></div>
            <div className="banner__content" style={contentStyle}>
                <div className="banner__content--text">
                    <div>
                        <div>
                            <h3>
                                <Translation id="online_visit" defaultMessage="Online visit" />
                            </h3>
                        </div>
                        <div>
                            <h5>
                                <Translation id="cosentino_centers" defaultMessage="Cosentino centers" />
                            </h5>
                        </div>
                    </div>
                    <div className="banner__content--info">
                        <p>
                            <Translation
                                id="explore_our_variety_of_colors_and_select_natural_stone_slabs"
                                defaultMessage="Explore our variety of colors and select Natural Stone slabs for your projects."
                            />
                        </p>
                    </div>
                </div>
                <div className="banner__content--btn">
                    <a href={onlineVisitUrl} target="_blank" rel="noopener noreferrer">
                        <button>
                            <Translation id="book_an_online_visit" defaultMessage="Book an Online Visit" />
                        </button>
                    </a>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        onlineVisitUrl: getOnlineVisitUrl(state)
    }
}

export default connect(mapStateToProps, null)(OnlineVisitBanner)
